import { gql } from '@apollo/client';

export const LOGIN = gql`
  mutation login(
    $email: String!
    $password: String!
  ) {
    login(email: $email, password: $password) {
      session
      error
    }
  }
`;

export const PASSWORD_CHANGE = gql`
  mutation passwordChange(
    $email: String!
    $oldPassword: String!
    $password1: String!
    $password2: String!
  ) {
    passwordChange(email: $email, oldPassword: $oldPassword, password1: $password1, password2: $password2) {
      session
      errorCode
      additionalMessages
    }
  }
`;
